import clsx from "clsx"

import styles from "./Card.module.scss"
import { CardProps } from "./Card.types"

export default function Card(props: CardProps) {
    const { children, className } = props

    return <div className={clsx(styles.base, className)}>{children}</div>
}
